import styled from 'styled-components';

import { device } from '@/styles/helpers';

export const ScPagination = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  button {
    outline: none;
    background: none;
    border: none;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    color: ${({ theme }) => theme.color2};
    width: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;

    @media (${device.mobileS}) {
      width: 20px;
    }

    &:disabled {
      cursor: no-drop;
    }

    & > svg {
      object-fit: contain;
      vertical-align: middle;
    }

    &.right-arrow {
      transform: rotate(180deg);
    }

    &:not(:disabled) {
      &:hover,
      &.active {
        color: ${({ theme }) => theme.whiteColor};

        & > svg path {
          fill: ${({ theme }) => theme.color2};
        }
      }

      @media (${device.mobile}) {
        &:not(.active):hover {
          color: ${({ theme }) => theme.color2};

          & > svg path {
            fill: ${({ theme }) => theme.color2};
          }
        }
      }
    }
  }
`;
